export default __webpack_public_path__ + "static/media/birds.e2d93af9.mp3";